<template>
  <div>
    <div class="StoreDetails">
      <div class="section1 page-body">
        <el-alert v-if="dataUpdate" title="Please Note" type="warning" show-icon>
          Store timings will be changed for the upcoming week cycle. Please check
          next week's schedule approximately after 5 minutes for the updated store
          timings.
        </el-alert>

        <div class="py-2">
          <div class="my-6">
            <el-row :gutter="20">
              <el-col :xs="8" :sm="8" :md="5" :lg="5" :xl="5">
                <p class="my-4 font-lbl-17">
                  Shift Type<span style="color: red"> * </span>
                </p>
              </el-col>
              <el-col :xs="24" :sm="5" :md="5" :lg="5" :xl="5">
                <el-select v-model="shift_type" v-validate="'required'" style="width: 100%"
                  :disabled=" test_store || outletAccess" placeholder="Select Shift" name="Shift Type"
                  @change="openPopup()">
                  <!-- <el-option value="fixed" label="fixed">
									Fixed
								</el-option> -->
                  <el-option value="flexible" label="flexible">
                    Flexible
                  </el-option>
                </el-select>
                <p>
                  <span :v-show="errors.has('Shift Type')" class="text-red-dark text-xs">
                    {{ errors.first("Shift Type") }}
                  </span>
                </p>
              </el-col>
            </el-row>
          </div>
          <div v-if="shift_type == 'fixed'">
            <BaseShiftTable :shifts="shifts"> </BaseShiftTable>
          </div>
          <!-- <el-row :gutter="10">
					<el-col :xs="24" :sm="24" :md="6" :lg="10" :xl="10">
						<p class="font-lbl-18 font-bold">
							Open for Business
						</p>
					</el-col>
				</el-row> -->
          <el-row class="my-2" :gutter="20">
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
              <div class="my-4 font-lbl-17">
                Open for Business 24 Hrs
                <span style="color: red">*</span>
              </div>
            </el-col>
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
              <el-select v-model="is_staff_24_hours" v-validate="'required'"
                :disabled=" test_store || isAdmin == 'super' || outletAccess" style="width: 100%"
                placeholder="select hours" :name="'is_staff_24_hours'" @change="changeHrsFormat()">
                <el-option v-for="(item, index1) in store_hours_list" :key="index1" :value="item.id" :label="item.name">
                  {{ item.name }}
                </el-option>
              </el-select>
            </el-col>
          </el-row>
          <!-- Business Hrs field -->
          <el-row v-if="(is_staff_24_hours == 1)" class="my-2" :gutter="20">
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                  <div class="my-4 font-lbl-17">
                    Business Start Time
                    <span style="color: red">*</span>
                  </div>
                </el-col>
                <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                  <el-select v-model="business_day_time" v-validate="'required'" clearable placeholder="Business Start Time"  
                  :disabled="test_store || isAdmin == 'super' || outletAccess"  style="width: 100%" >
                        <el-option
                          v-for="time_item in from_time_slot"
                          :key="time_item.value"
                          :label="time_item.label"
                          :value="time_item.value">
                        </el-option>
                      </el-select>
                </el-col>
              </el-row>

          <el-row :gutter="10">
            <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24">
              <div class="mb-2"></div>
            </el-col>
          </el-row>

          <!-- <div class="mt-4">
            <el-checkbox v-model="isClosed" :disabled="
              test_store ||
              is_staff_24_hours == 1 ||
              isAdmin == 'super' || outletAccess
            " @change="setCloseAll()">
              <span class="txt font-lbl-17">Applicable to all days
                <span style="color: red">*</span>
              </span>
            </el-checkbox>
          </div> -->

          <!-- <template v-if="isClosed">
            <el-row :gutter="20">
              <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
                <div class="mb-2">
                  <span class="font-lbl-17">Business Hrs</span>
                </div>
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <div class="mb-2">
                  <p class="font-lbl-17">From</p>
                </div>
                <el-select v-model="is_staff_start_hours" clearable placeholder="From Time" :disabled="
                    !isClosed ||
                    is_staff_24_hours == 1 ||
                    isAdmin == 'super' ||
                    test_store  || outletAccess
                  " @change="changeFromTime(is_staff_start_hours), addCloseTime()">
                    <el-option
                      v-for="item in from_time_slot"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-col>
              <el-col :xs="3" :sm="3" :md="3" :lg="3" :xl="3">
                <div class="mb-2">
                  <p class="font-lbl-17">To</p>
                </div>
                <el-select v-model="is_staff_end_hours" clearable placeholder="To Time" :disabled="
                    !isClosed ||
                    
                    is_staff_24_hours == 1 ||
                    isAdmin == 'super' ||
                    test_store || outletAccess ||
                    !is_staff_start_hours
                  " @change="addCloseTime(), changeToTime(is_staff_end_hours)">
                    <el-option
                      v-for="item in to_time_slot"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value">
                    </el-option>
                  </el-select>
              </el-col>
              <el-col :xs="9" :sm="9" :md="9" :lg="9" :xl="9" class="flex items-center">
                
                <div v-if="shift_type == 'flexible'">
                  <div class="mb-2">
                    <p class="font-lbl-17">Pre Opening Hrs</p>
                  </div>
                  <el-select v-model="pre_opening_hour" filterable :disabled="
                      is_staff_24_hours == 1 ||
                      isAdmin == 'super' ||
                      test_store || outletAccess ||
                      !is_staff_start_hours || !is_staff_end_hours ||
                      shift_duration == '24'
                    " style="width: 100px" placeholder="hours" :name="'is_staff_24_hours'" @change="openPopup()">
                      <el-option v-for="(hr, index1) in preOpeningAndPostClosingRange2(shift_duration)" :key="index1" :value="hr" :label="hr">
                        {{ hr }}
                      </el-option>
                  </el-select>
                </div>

                <div v-if="shift_type == 'flexible'" class="ml-4">
                  <div class="mb-2">
                    <p class="font-lbl-17">Post closing Hrs</p>
                  </div>
                  <el-select v-model="post_opening_hour" filterable :disabled="
                      is_staff_24_hours == 1 ||
                      isAdmin == 'super' ||
                      test_store || outletAccess ||
                      !is_staff_start_hours || !is_staff_end_hours ||
                      shift_duration == '24'
                    " style="width: 100px" placeholder="hours" :name="'is_staff_24_hours'" @change="openPopup()">
                      <el-option v-for="(hr, index1) in preOpeningAndPostClosingRange2(shift_duration)" :key="index1" :value="hr" :label="hr">
                        {{ hr }}
                      </el-option>
                    </el-select>
                </div>
                <div class="ml-4">
                  <div>
                    <p class="font-lbl-17">Duration</p>
                  </div>
                  <p style="padding: 14.5px 0;">{{ getShiftDuration(is_staff_start_hours, is_staff_end_hours, pre_opening_hour, post_opening_hour) + ' Hrs' }}</p>
                </div>
              </el-col>
            </el-row>
          </template> -->

          <table v-if="is_staff_24_hours == 2"  class="table mt-4">
            <thead>
              <tr>
                <th class="font-lbl-17" style="padding: 0; width: 31.5%">
                  Business Hrs
                </th>
                <th></th>
                <th>
                  From 
                </th>
                <th>To </th>
                <th v-if="shift_type == 'flexible'">Pre Opening Hrs</th>
                <th v-if="shift_type == 'flexible'">Post closing Hrs</th>
                <th>
                  <span class="pl-5">Duration</span> 
                </th>
                <th>&nbsp;</th>
              </tr>
            </thead>

            <tbody v-for="(item, itemIndex) in openforBusiness" :key="itemIndex">
              <tr>
                <td class="font-lbl-16" style="padding: 0; width: 31.5%">
                  <!-- {{itemIndex == 0 ? "Business Hrs" : ""}} -->
                </td>
                <td>
                  <p v-for="(days, daysIndex) in store_days_code" :key="daysIndex"
                    class="font-bold flex items-center">
                    <span v-if="days.id == item.day" style="margin-top: 15px">
                      {{ days.day.substring(0, 3) }}
                    </span>
                  </p>
                  &nbsp;
                </td>
                <td>
                  <!-- <el-time-select v-model="item.opening_time" v-validate="!item.closed ? 'required' : ''" :disabled="
                    item.closed == true ||
                    
                    isAdmin == 'super' ||
                    test_store
                  " style="width: 150px" :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '23:59',
                  }" placeholder="Hrs:Mins" :name="'opening_time' + itemIndex"
                    @change="changeOpeningTime(itemIndex, item.opening_time)">
                  </el-time-select> -->
                  <el-select v-model="item.opening_time" v-validate="!item.closed ? 'required' : ''" clearable placeholder="From Time" :disabled="
                    item.closed == true ||
                    isAdmin == 'super' ||
                    test_store
                  " style="width: 150px" @change="changeOpeningTime(itemIndex, item.opening_time), updateDuration(item.opening_time, item.closing_time, item.pre_opening_hour, item.post_opening_hour, itemIndex, item.to_time_slot, 'opening_time')">
                    <el-option
                      v-for="time_item in from_time_slot"
                      :key="time_item.value"
                      :label="time_item.label"
                      :value="time_item.value">
                    </el-option>
                  </el-select>
                </td>
                <td>
                  <!-- <el-time-select v-model="item.closing_time" v-validate="!item.closed ? 'required' : ''" :disabled="
                    item.closed == true ||
                    
                    isAdmin == 'super' ||
                    test_store
                  " style="width: 150px" :picker-options="{
                    start: '00:00',
                    step: '00:30',
                    end: '23:59',
                  }" placeholder="Hrs:Mins" :name="'closing_time' + itemIndex" @change="
                    changeClosingTime(
                      itemIndex,
                      item.closing_time,
                      item.opening_time
                    )
                  ">
                  </el-time-select> -->
                  
                  <el-select v-model="item.closing_time" v-validate="!item.closed ? 'required' : ''" clearable placeholder="To Time" :disabled="
                    item.closed == true ||
                    isAdmin == 'super' ||
                    test_store ||
                    !item.opening_time
                  " style="width: 150px"  @change="
                    changeClosingTime(
                      itemIndex,
                      item.closing_time,
                      item.opening_time
                    ),
                    updateDuration(item.opening_time, item.closing_time, item.pre_opening_hour, item.post_opening_hour, itemIndex, item.to_time_slot, 'closing_time') 
                  ">
                    <el-option
                      v-for="time_item in item.to_time_slot"
                      :key="time_item.value"
                      :label="time_item.label"
                      :value="time_item.value">
                    </el-option>
                  </el-select>
                </td>
                <td v-if="shift_type == 'flexible'">
                  <el-select v-model="item.pre_opening_hour" filterable style="width: 100px" placeholder="hours"
                    :disabled="
                      item.closed == true ||
                      
                      isAdmin == 'super' ||
                      test_store ||
                      !item.opening_time || !item.closing_time
                    " :name="'is_staff_24_hours'" @change="openPopup(), updateDuration(item.opening_time, item.closing_time, item.pre_opening_hour, item.post_opening_hour, itemIndex, item.to_time_slot, 'pre_opening_hour')">
                    <el-option v-for="(hr, index1) in  opening_closing_hrs" :disabled="((item.duration - item.pre_opening_hour) + hr) > 24"
                     :key="index1"  :value="hr" :label="hr">
                      {{ hr }}
                    </el-option>
                  </el-select>
                </td>
                <td v-if="shift_type == 'flexible'">
                  <el-select v-model="item.post_opening_hour" filterable style="width: 100px" placeholder="hours"
                    :disabled="
                      item.closed == true ||
                      
                      isAdmin == 'super' ||
                      test_store ||
                      !item.opening_time || !item.closing_time
                    " :name="'is_staff_24_hours'" @change="openPopup(), updateDuration(item.opening_time, item.closing_time, item.pre_opening_hour, item.post_opening_hour, itemIndex, item.to_time_slot, 'post_opening_hour')">
                    <el-option v-for="(hr, index1) in opening_closing_hrs" :disabled="((item.duration - item.post_opening_hour) + hr) > 24"
                     :key="index1" :value="hr" :label="hr">
                      {{ hr }}
                    </el-option>
                  </el-select>
                </td>
                <td class="pl-5">
                  <span class="pl-5 text-sm">{{ (item.duration ? item.duration : 0) + ' Hrs' }}</span> 
                </td>
                <td>
                  <el-checkbox v-model="item.closed" @change="openPopup()" class="m-2">
                    <span class="txt">Closed</span>
                  </el-checkbox>
                </td>
              </tr>
            </tbody>
          </table>

          <el-row class="py-2">
            <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
              <p class="font-lbl-17 pt-8 pb-1">
                Restricted Shift Hrs
                <!-- <span style="color:red;"> * </span> -->
              </p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
              <div class="flex">
                <div>
                  <p class="font-lbl-17 pt-3 pb-1">From</p>
                  <div class="pl-1">
                    <div class="custom-time-picker-wrapper">
                      <i class="el-icon-time time-icon"></i>

                      <el-select v-model="restricted_start_time"  :disabled=" test_store || isAdmin == 'super' || outletAccess"
                        placeholder="HH:mm" name="Time Gap between two shifts" style="width: 150px"
                        @change="checkTime(restricted_start_time)" class="custom-time-picker" clearable>
                        <el-option v-for="(time, index) in restricted_time_slots_from" :label="time.time"
                          :value="time.formated_time" :key="index"></el-option>
                      </el-select>
                    </div>

                    <!-- <el-time-select
								v-model="restricted_start_time"
								:disabled="isAdmin != 'admin' || test_store"
								:picker-options="{
									start: '00:00',
									step: '00:30',
									end: '23:59'
								}"
								style="width: 100%;"
								placeholder="HH:mm"
								name="Time Gap between two shifts"
								@change="checkTime(restricted_start_time)"
							>
							</el-time-select> -->
                  </div>
                  <!-- <p>
							<span
								v-show="errors.has('Time Gap between two shifts')"
								class=" text-red-dark text-xs"
							>
								{{ errors.first("Time Gap between two shifts") ? "field is required" : "" }}
							</span>
						</p> -->
                </div>
                <div class="pl-4">
                  <p class="font-lbl-17 pt-3 pb-1">To</p>
                  <div>
                    <div class="custom-time-picker-wrapper">
                      <i class="el-icon-time time-icon"></i>

                      <el-select v-model="restricted_end_time"  :disabled=" test_store || isAdmin == 'super' || outletAccess"
                        placeholder="HH:mm" name="Time Gap between two shifts" style="width: 150px"
                        class="custom-time-picker" clearable>
                        <el-option v-for="(time, index) in restricted_time_slots_to" :label="time.time"
                          :value="time.formated_time" :key="index"></el-option>
                      </el-select>
                    </div>
                    <!-- <el-time-select
									v-model="restricted_end_time"
									:disabled="isAdmin != 'admin' || test_store"
									:picker-options="{
										start: restricted_start_time,
										step: '00:30',
										end: newTime
									}"
									style="width: 100%;"
									placeholder="HH:mm"
									name="Time Gap between two shifts"
								>
								</el-time-select> -->
                  </div>
                  <!-- <p>
								<span
									v-show="errors.has('Time Gap between two shifts')"
									class=" text-red-dark text-xs"
								>
									{{ errors.first("Time Gap between two shifts") ? "field is required" : "" }}
								</span>
							</p> -->
                </div>
              </div>
            </el-col>
          </el-row>

          <!-- <el-row class="py-2">
          <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5">
            <p class="font-lbl-17 pt-8 pb-1">
              Day Part
            </p>
          </el-col>

          <el-col :xs="24" :sm="24" :md="8" :lg="8" :xl="8">
            <p class="font-lbl-17 pt-3 pb-1">Title</p>
            <div class="flex mt-4" v-for="(i, index) in day_part_obj" :key="index">
              <div>
                <el-input
                  style="width: 150px; margin-left: 3px"
                  v-model="i.day_part_title"
                  placeholder="Add day part"
                ></el-input>
              </div>
              <div>
                <div class="pl-4">
                  <div class="custom-time-picker-wrapper">
                    <i class="el-icon-time time-icon"></i>

                    <el-select
                      v-model="i.day_part_start_time"
                      :disabled="isAdmin != 'admin' || test_store"
                      placeholder="HH:mm"
                      name="Time Gap between two shifts"
                      style="width: 150px"
                      class="custom-time-picker"
                      clearable
                    >
                      <el-option
                        v-for="(time, index) in restricted_time_slots_from"
                        :label="time.time"
                        :value="time.formated_time"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>
              <div class="pl-4">
                <div>
                  <div class="custom-time-picker-wrapper">
                    <i class="el-icon-time time-icon"></i>

                    <el-select
                      v-model="i.day_part_end_time"
                      :disabled="isAdmin != 'admin' || test_store"
                      placeholder="HH:mm"
                      name="Time Gap between two shifts"
                      style="width: 150px"
                      class="custom-time-picker"
                      clearable
                    >
                      <el-option
                        v-for="(time, index) in restricted_time_slots_to"
                        :label="time.time"
                        :value="time.formated_time"
                        :key="index"
                      ></el-option>
                    </el-select>
                  </div>
                </div>
              </div>

              <div>
                <img v-if="day_part_obj.length > 1" src="../../../../../assets/images/delete-icon.png" class="day-part-img" @click="addRemoveDayPartObj('remove', index)" alt="">
              </div>
            </div>

            <BaseButton
              buttonclass="btn p-2 text-xs mt-4"
              style="width: 100px"
              @click="addRemoveDayPartObj('add')"
            >
              Add More
            </BaseButton>
          </el-col>
        </el-row> -->

          <!-- <el-row class="mt-10" :gutter="20">
            <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="5">
              <p class="my-4 font-lbl-17">Dine in (No. of seats)</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-row>
                <el-col :xs="5" :sm="5" :md="9" :lg="9" :xl="9">
                  <el-select v-model="dine_in_seats" filterable style="width: 100px" placeholder="Select">
                    <el-option v-for="(seat, seat_index) in Array(501).keys()" :key="seat_index" :value="seat"
                      :label="seat">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row> -->

          <el-row class="my-2" :gutter="20">
            <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="5">
              <p class="my-4 font-lbl-17">No. of Restrooms</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-row>
                <el-col :xs="5" :sm="5" :md="9" :lg="9" :xl="9">
                  <el-select v-model="restrooms" :disabled="outletAccess" filterable style="width: 100px" placeholder="Select">
                    <el-option v-for="(room, room_index) in Array(21).keys()" :key="room_index" :value="room"
                      :label="room">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <!-- <el-row class="my-2" :gutter="20">
            <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="5">
              <p class="my-4 font-lbl-17">Drive Through</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-row>
                <el-col :xs="5" :sm="5" :md="9" :lg="9" :xl="9">
                  <el-select v-model="drive_through" filterable style="width: 100px" placeholder="Select">
                    <el-option :value="true" label="Yes"></el-option>
                    <el-option :value="false" label="No"></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row> -->

          <el-row class="my-2" :gutter="20">
            <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="5">
              <p class="my-4 font-lbl-17">Levels</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-row>
                <el-col :xs="5" :sm="5" :md="9" :lg="9" :xl="9">
                  <el-select v-model="levels" :disabled="outletAccess" filterable style="width: 100px" placeholder="Select">
                    <el-option v-for="(level, level_index) in Array(11).keys()" :key="level_index" :value="level"
                      :label="level">
                    </el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-col>
          </el-row>

          <el-row class="my-2" :gutter="20">
            <el-col :xs="6" :sm="6" :md="5" :lg="5" :xl="5">
              <p class="my-4 font-lbl-17">Store Size</p>
            </el-col>

            <el-col :xs="24" :sm="24" :md="16" :lg="16" :xl="16">
              <el-row>
                <el-col :xs="5" :sm="5" :md="9" :lg="9" :xl="9">
                  <el-input v-model="store_size" :disabled="outletAccess" style="width: 100px"></el-input>

                  &nbsp;

                  <strong style="font-size: 0.7rem; color: #999">(In Sq. Ft.)</strong>
                </el-col>
              </el-row>
            </el-col>
          </el-row>


           
        </div>
      </div>

      <!-- <div>
        <el-row class="card text-right my-2 border-top-btn-sec" :gutter="20">
          <el-col :xs="22" :sm="22" :md="22" :lg="22" :xl="22">
            <div style="width: 6rem; float: right">
              <BaseButton buttonclass="btn p-2 text-sm orng-btn"
                :disabled=" test_store || isAdmin == 'super' || isUpdateSection  || outletAccess"
                @click="addStoreDetails">
                Save
              </BaseButton>
            </div>
          </el-col>
        </el-row>
      </div> -->

      <el-dialog title="Confirm" :visible.sync="isShowPopUp" width="40%">
        <span>Are you sure you want to continue without saving changes? Yes/No</span>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="isShowPopUp = false">No</el-button>
          <el-button type="warning" size="mini" @click="changeUrl">Yes</el-button>
        </span>
      </el-dialog>
    </div>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { serverAddr } from "../../../../../networkConfig";
import { EventBus } from "../../../../../eventBus";
import moment from "moment";
import BaseShiftTable from "../staff/baseShiftTable/BaseShiftTable";
import LabourPalnningService from "../../../../../services/labourPalnningService";
import { Empty } from "element-ui";

export default {
  name: "StoreDetails",

  components: {
    BaseShiftTable,
  },

  data() {
    return {
      sectionField: [],
      createSections: {},
      shift_type: "",
      StoreId: "",
      sectionTableLoading: false,
      isUpdateSection: false,
      shifts: [
        {
          min_staff_required: null,
          shift_end_time: null,
          shift_name: "",
          shift_start_time: null,
        },
      ],
      isAdmin: "",
      test_store: false,
      dataUpdate: false,
      changeKeys: false,
      isShowPopUp: false,
      isRouteChanged: false,
      path: "",
      pre_opening_hour: "",
      pre_opening_min: 0,
      post_opening_hour: "",
      post_opening_min: 0,
      isClosed: false,
      is_staff_start_hours: "",
      is_staff_end_hours: "",
      store_hours_list: [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
      ],
      is_staff_24_hours: 2,
      business_day_time: '',
      no_of_floors: "",
      no_of_tables: "",
      store_details: {},
      store_close_id_list: [],
      Store_Closed_On_list: [],
      store_days_code: [
          {
              "id": 2,
              "day": "Monday"
          },
          {
              "id": 3,
              "day": "Tuesday"
          },
          {
              "id": 4,
              "day": "Wednesday"
          },
          {
              "id": 5,
              "day": "Thursday"
          },
          {
              "id": 6,
              "day": "Friday"
          },
          {
              "id": 7,
              "day": "Saturday"
          },
          {
              "id": 8,
              "day": "Sunday"
          },
          {
              "id": 1,
              "day": "Open All Days"
          }
      ],
      opening_hours: "",
      closing_hours: "",
      post_opening_time: "00:00",
      pre_opening_time: "00:00",
      seating_capacity: "",
      full_time: "",
      change_time: false,
      openforBusiness: [
        {
          day: 2,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 3,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 4,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 5,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 6,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 7,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
        {
          day: 8,
          opening_time: "",
          closing_time: "",
          pre_opening_hour: "",
          pre_opening_min: 0,
          post_opening_hour: "",
          post_opening_min: 0,
          closed: false,
          to_time_slot:[],
          duration: 0,
        },
      ],

      first_opening_time: false,
      first_closing_time: false,
      StoreCompany: "",
      StoreDetailsId: "",
      dine_in_seats: 0,
      restrooms: 0,
      drive_through: "false",
      levels: 0,
      store_size: 0,
      restricted_start_time: "",
      restricted_end_time: "",
      restricted_time_slots_from: [],
      restricted_time_slots_to: [],
      planning_shift_day: "",
      day_part_obj: [
        {
          day_part_title: "Breakfast",
          day_part_start_time: "10:00",
          day_part_end_time: "11:00",
        },
        {
          day_part_title: "Lunch",
          day_part_start_time: "13:00",
          day_part_end_time: "16:00",
        },
        {
          day_part_title: "Evening",
          day_part_start_time: "16:00",
          day_part_end_time: "19:00",
        },
        {
          day_part_title: "Dinner",
          day_part_start_time: "19:00",
          day_part_end_time: "22:00",
        },
        {
          day_part_title: "Night",
          day_part_start_time: "22:00",
          day_part_end_time: "23:00",
        },
        {
          day_part_title: "",
          day_part_start_time: "",
          day_part_end_time: "",
        },
      ],
      oldSectionDetails: [],
      from_time_slot: [],
      to_time_slot: [],
      pickerOptions: {
        format: 'hh:mm a', // 12-hour format with am/pm
        selectableRange: '00:00:00 - 23:59:59', // Optional: limit the selectable range
        step: '00:30',
      },
      shift_duration: null,
      opening_closing_hrs: [0,0.5,1,1.5,2,2.5,3,3.5,4,4.5,5,5.5,6,6.5,7],
      staff_details: {},
      store_staff_info: {},
    };
  },

  computed: {
    ...mapState("LabourPlanning", ["storeName", "sectionDetailsData", "sectionTableLoadingStore"]),
    store_id() {
      return localStorage.getItem('store_id');
    },
    sectionDetails() {
      let data = this.sectionDetailsData;
      return data;
    },
    adminAccess(){
			return this.isAdmin === 'admin';
		},
    checkCompany(){
      return JSON.parse(localStorage.getItem('check_company'));
    },
		regionAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'region' && checkCompany.is_mcd;
		},
		sub_regionAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'sub_region' && checkCompany.is_mcd;
		},
		outletAccess(){
			const checkCompany = JSON.parse(localStorage.getItem('check_company'));
			return this.isAdmin === 'outlet' && checkCompany.is_mcd;
		},
  },

  mounted() {
    EventBus.$on("updateStoreData", this.changedStore);

    EventBus.$on("updatedStoreDetails", item => {
      this.getStoreDetails();
		});
    EventBus.$on('saveStoreDetails', (payload) => {
      this.addStoreDetails();
    });

    if(this.storeName) {
      this.getStoreDetails();
    }
    if(localStorage.getItem('store')){
      setTimeout(() => {
        this.$store.commit("LabourPlanning/SET_STORE_NAME", localStorage.getItem('store'))
      // this.storeName = localStorage.getItem('store');
    }, 2500);
    }
  },

  beforeDestroy() {
    EventBus.$off("saveStoreDetails");
    // EventBus.$off("updateStoreData", this.getStoreDetails);
    // if (this.isUpdateSection) {
    //   let result = confirm("Do you want to save changes?")
    //   result ? this.updateSectionDetails() : '';
    // }
  },

  // beforeMount() {
  //   if (this.isUpdateSection) {
  //     let result = confirm("Do you want to save changes?")
  //     result ? this.updateSectionDetails() : '';
  //   }
  // },

  created() {
    this.isAdmin = localStorage.getItem("user_access_level");
    LabourPalnningService.getStoreClosedOnDropdown().then((response) => {
      this.Store_Closed_On_list = JSON.parse(response.data);
    });

    this.restricted_time_slots_from = this.genereateTimeSlotS("00:00", "23:30");
    this.restricted_time_slots_to = this.genereateTimeSlotS("00:00", "23:30");

    
    // this.getSectionDetailsAction();
  },

  methods: {
    ...mapActions("LabourPlanning", ["getSectionDetailsAction"]),
    generateStartTime(intervalMinutes) {
      const start = moment().startOf('day');
      const end = moment().startOf('day').add(24, 'hours');
      const timeSlots = [];

      while (start.isBefore(end)) {
        const timeLabel = start.format('HH:mm');
        const timeValue = start.format('HH:mm:ss');
        
        timeSlots.push({
          label: moment(timeLabel, 'HH:mm').format('hh:mm A'),
          value: moment(timeValue, 'HH:mm:ss').format('HH:mm:ss'),
          formatted: moment(timeValue, 'HH:mm:ss').format('YYYY-MM-DDTHH:mm:ss')
        });

        start.add(intervalMinutes, 'minutes');
      }

      return timeSlots;
    },
    updateDuration(opening_time ,closing_time ,pre_opening_hour ,post_opening_hour, itemIndex, timeArr, changed){
      const duration = this.getShiftDuration(opening_time ,closing_time ,pre_opening_hour ,post_opening_hour, timeArr);
      console.log(duration,changed, 'duration')
      this.openforBusiness[itemIndex].duration = duration;
      if(duration <= 0 || duration > 24){
        if(changed === 'closing_time') {
          this.openforBusiness[itemIndex].pre_opening_hour = '';
          this.openforBusiness[itemIndex].post_opening_hour = '';
        } else if(changed === 'pre_opening_hour' || changed === 'post_opening_hour') {
          this.openforBusiness[itemIndex][changed] = '';
        }
        // this.openforBusiness[itemIndex].pre_opening_hour = '';
        // this.openforBusiness[itemIndex].post_opening_hour = '';
      }
      this.$forceUpdate();
    },
    generateEndTime(start, interval, count) {
      console.log(start, interval, count, 'start, interval, count');
      const timeSlots = [];
      let moment_start = moment(start);
      let nextDayTime = '';
      for (let i = 0; i < count; i++) {
        const currentTime = moment_start.clone().add(i * interval, 'minutes');
        // console.log(currentTime.toDate(), 'currentTime');

        const formatted12Hour = currentTime.format('hh:mm A');
        const formatted24Hour = currentTime.format('HH:mm');
        const dateString = currentTime.format('YYYY-MM-DD');

        if (currentTime.isBefore(moment_start, 'hour')) {
          currentTime.add(1, 'day');
          dateString = currentTime.format('YYYY-MM-DD');
        }

        const label = formatted12Hour;
        const formatted = `${dateString}T${formatted24Hour}:00`;
        const value = currentTime.format('HH:mm:ss');

        if(formatted !== start) {
          timeSlots.push({ label, value, formatted });
        } else if(formatted === start) {
          nextDayTime = { label, value, formatted: moment(formatted).add(1, 'day').format("YYYY-MM-DDTHH:mm:ss") };
          console.log(formatted, start, 'ASASAS');
        }
      }

      if(nextDayTime){
        timeSlots.push(nextDayTime);
      }

      return timeSlots;
    },
    changeFromTime(fromTime){
      let startTime = moment(fromTime, "HH:mm:ss").add(30, 'minutes');
      const startTimeFormatted = this.from_time_slot.find((e)=> e.value === fromTime)
      this.to_time_slot = this.generateEndTime(startTimeFormatted.formatted, 30, 48);
      console.log('');
      // Validate duration
      const duration = this.getShiftDuration(this.is_staff_start_hours, this.is_staff_end_hours, this.pre_opening_hour, this.post_opening_hour);
      if((duration > 24 || duration <= 0) && (this.is_staff_start_hours && this.is_staff_end_hours)) {
        this.is_staff_start_hours = '';
        this.$forceUpdate();
      }
      // this.to_time_slot = this.generateEndTime(startTime, 30);
    },
    changeToTime(fromTime){
      // let startTime = moment(fromTime, "HH:mm:ss").add(30, 'minutes');
      // const startTimeFormatted = this.from_time_slot.find((e)=> e.value === fromTime)
      // this.to_time_slot = this.generateEndTime(startTimeFormatted.formatted, 30, 48);
      // Validate duration
      const duration = this.getShiftDuration(this.is_staff_start_hours, this.is_staff_end_hours, this.pre_opening_hour, this.post_opening_hour);
      if((duration > 24 || duration <= 0) && (this.is_staff_start_hours && this.is_staff_end_hours)) {
        this.is_staff_end_hours = '';
        this.$forceUpdate();
      }
      // this.to_time_slot = this.generateEndTime(startTime, 30);
    },
    getDuration(start, end) {
      const startTime = moment(start, 'HH:mm:ss');
      const endTime = moment(end, 'HH:mm:ss');
      const duration = moment.duration(endTime.diff(startTime));
      const hours = Math.floor(duration.asHours());
      const minutes = duration.minutes();
      const formattedDuration = `${hours}.${minutes.toString().padStart(2, '0')}`;

      return formattedDuration;
    },
    getShiftDuration(start, end, pre, post, timeArr=[]) {
      console.log(start, end, pre, post,timeArr, 'start, end, pre, post')
      pre = pre ? parseFloat(pre) : 0;
      post = post ? parseFloat(post) : 0;
      if((this.is_staff_24_hours == 1)) {
        return 24 + parseInt(this.pre_opening_hour) + parseInt(this.post_opening_hour);
      }
      let totalShiftHours = 0;
      if(start && end) {
        const startTime = moment(this.from_time_slot.find((e)=> e.value === start).formatted);
        const endTime = timeArr.length ? moment(timeArr.find((e)=> e.value === end).formatted)  : moment(this.to_time_slot.find((e)=> e.value === end).formatted);
        console.log(endTime.diff(startTime, 'minutes'),pre,post, 'endTime.diff(startTime)');

        // const duration = moment.duration(endTime.diff(startTime));
        
        // const hours = duration.hours();
        // const minutes = duration.minutes();
        // const totalHours = hours + (minutes / 60); // Calculate the total duration in hours

        // Adding pre and post decimal values
        totalShiftHours = (endTime.diff(startTime, 'minutes') / 60) + pre + post;
        console.log(totalShiftHours, 'totalShiftHours')
        this.shift_duration = totalShiftHours;
        // this.shift_duration = parseInt(totalShiftHours) ? parseFloat(totalShiftHours).toFixed(1) : 0;
        if(this.shift_duration > 24 || this.shift_duration <= 0){
          this.$message.error('Please ensure store timings are within a 24-hour format.');
          totalShiftHours = 0;
          this.shift_duration = 0;
          // this.is_staff_end_hours = '';
          this.$forceUpdate();
        }
      }
      return totalShiftHours;
    },
    calculateDuration(start, end) {
      const startTime = moment(start, 'HH:mm:ss');
      const endTime = moment(end, 'HH:mm:ss');
      const duration = moment.duration(endTime.diff(startTime));
      
      const hours = duration.hours();
      const minutes = duration.minutes();
      const totalHours = hours + (minutes / 60);

      return totalHours.toFixed(1); 
    },
    makeSectionEditable(editable, id) {
      this.isUpdateSection = true;
      this.sectionDetails.forEach(section => {
        if (section.id == id && editable) {
          section.is_editable = true;
        } else if (section.id == id && !editable) {
          section.is_editable = false;
          this.oldSectionDetails.map(oldSection => {
            if (oldSection.id == id) {
              section.name = oldSection.name;
              section.section_close_time = oldSection.section_close_time;
              section.section_open_time = oldSection.section_open_time;
            }
          });
        }
      });

      // if all section is not editable then isUpdateSection is false
      if (!this.sectionDetails.some(section => section.is_editable)) {
        this.isUpdateSection = false;
      }
      // refresh the vue component
      this.$forceUpdate();
    },

    updateSectionDetails(id) {

      this.sectionTableLoading = true;
      this.$validator.validateAll().then(result => {
        const params = {
          store: this.StoreId,
          sections_data: []
        }
        this.sectionDetails.forEach(section => {
          if (section.id == id) {
            params.sections_data.push(section);
          }
        });


        this.$confirm('Do you want to update sections ?', 'Warning', {
          confirmButtonText: 'Yes',
          cancelButtonText: 'No',
          type: 'warning'
        }).then(() => {

          // Check Duplicate records
          var duplicate = false;
          params.sections_data.map(item => {
            this.sectionDetails.map(section => {
              if ((item.name.toUpperCase().trim() == section.name.toUpperCase().trim()) && (item.id != section.id)) {
                duplicate = true;
                console.log("Duplicate", item.name, section.name);
              }
            });
          });

          if (duplicate) {
            this.$notify.warning({
              title: "Warning",
              message: "This section already exists",
            })
            this.sectionTableLoading = false;
            return;
          }
          LabourPalnningService.addSections(params)
            .then((response) => {
              this.sectionTableLoading = false;
              this.isUpdateSection = false;
              this.getSectionDetailsAction(this.StoreId);
              if (response.status == 200) {
                // this.$message.success("Section Updated successfully");
                this.$notify.success({
                  title: "Success",
                  message: "Section Updated successfully",
                })
              }
              this.sectionField = [];
            })
            .catch((err) => {
              this.getSectionDetailsAction(this.StoreId);
              this.sectionTableLoading = false;
              this.sectionField = [];
              console.log(err);
            });
        }).catch((err) => {
          this.sectionTableLoading = false;
          this.makeSectionEditable(false, id)
        });
        // refresh the vue component
        this.$forceUpdate();
      });
    },
    createNewSection() {
      this.sectionTableLoading = true;
      this.$validator.validateAll().then(result => {
        if (result) {
          this.sectionField.forEach(section => {
            this.createSections.sections_data.push(section);
          });

          // Check Duplicate records
          var duplicate = false;
          this.createSections.sections_data.map(item => {
            this.sectionDetails.map(section => {
              // Remove white spaces from both ends of the string 
              if (item.name.toUpperCase().trim() === section.name.toUpperCase().trim()) {
                duplicate = true;
                // pull that section from array
                this.createSections.sections_data.splice(this.createSections.sections_data.indexOf(item), 1);
              }
            });
          });

          if (duplicate) {
            this.$notify.warning({
              title: "Warning",
              message: "This Section already exists",
            })
            this.isUpdateSection = false;
            this.sectionTableLoading = false;
            return;
          } else {
            LabourPalnningService.addSections(this.createSections)
              .then((response) => {
                this.sectionTableLoading = false;
                this.isUpdateSection = false;
                this.getSectionDetailsAction(this.StoreId);
                if (response.status == 200) {
                  this.$notify.success({
                    title: "Success",
                    message: "New section is added successfully",
                  })
                }
                this.sectionField = [];
                this.createSections.sections_data = [];
              })
              .catch((err) => {
                this.sectionTableLoading = false;
                this.sectionField = [];
                console.log(err);
              });
          }
        } else {
          this.sectionTableLoading = false;
          this.$notify.error({
            title: "Enter missing fields",
            message: "Please enter required fields"
          });
        }
      });
    },
    deleteSelectedStore(id) {
      this.sectionTableLoading = true;
      const obj = {
        section: id,
      }

      this.$confirm('Do you want to delete this section ?', 'Warning', {
        confirmButtonText: 'Yes',
        cancelButtonText: 'No',
        type: 'warning'
      }).then(() => {
        LabourPalnningService.deleteSections(obj)
          .then((response) => {
            this.sectionTableLoading = false;
            this.getSectionDetailsAction(this.StoreId);
            if (response.status == 200) {
              this.$notify.success({
                title: "Success",
                message: "Section deleted successfully",
              });
            }
          })
          .catch((err) => {
            this.sectionTableLoading = false;
            console.log(err);
          });
      }).catch(() => {
        this.sectionTableLoading = false;
        this.$message({
          type: 'info',
          message: 'Delete canceled'
        });
      });
    },
    removeSectionField(index) {
      this.isUpdateSection = false;
      this.sectionField.splice(index, 1);
    },
    addSectionField() {
      const obj = {
        name: '',
        section_open_time: '',
        section_close_time: '',
        applicable_functions: [],
        transaction_threshold: 0,
        department: null,
      }
      this.sectionField.push(obj);

      // Check this.createSections is empty or not
      if (Object.keys(this.createSections).length === 0) {
        const obj2 = {
          store: this.StoreId,
          sections_data: []
        }
        this.createSections = obj2;
      }
    },
    addRemoveDayPartObj(action, index) {
      console.log(this.day_part_obj);
      if (action == "add") {
        this.day_part_obj.push({
          day_part_title: "",
          day_part_start_time: "",
          day_part_end_time: "",
        });
      } else {
        this.day_part_obj.splice(this.day_part_obj[index], 1)
      }
    },
    genereateTimeSlotS(start_time_slot, end_time_slot) {
      // calculate 30 mins duration
      let interval = 30;
      let period = "minutes";
      let periods_in_a_day = moment.duration(1, "day").as(period);
      let time_labels = [];

      let start_time = start_time_slot;
      let end_time = end_time_slot;

      let start_time_moment = moment(start_time, "HH:mm");

      for (let i = 0; i < periods_in_a_day; i += interval) {
        start_time_moment.add(i === 0 ? 0 : interval, period);
        let obj = {
          time: start_time_moment.format("HH:mm"),
          datetime: start_time_moment.format("YYYY-MM-DD HH:mm:ss"),
          formated_time: start_time_moment.format("HH:mm"),
        };
        time_labels.push(obj);

        if (end_time == start_time_moment.format("HH:mm")) {
          break;
        }
      }

      // console.log(time_labels);
      return time_labels;
    },

    checkTime(time) {
      var date = moment(moment().format("YYYY-MM-DD") + " " + time).format(
        "YYYY-MM-DD HH:mm"
      ); //set time to date
      let newTime = moment(date).add(10, "hours").format("HH:mm"); //add 10 hours

      this.restricted_end_time = "";
      this.restricted_time_slots_to = this.genereateTimeSlotS(time, newTime); //get time slots
    },

    changedStore() {
      this.getStoreDetails();
      this.dataUpdate = false;
    },

    hourCountForPreAndPostOpning(start_time, end_time) {
      let date = new Date();
      let start_date = moment(date).format("YYYY-MM-DD");
      let end_date = "";
      if (start_time < end_time) {
        end_date = moment(date).format("YYYY-MM-DD");
      } else {
        end_date = moment(date.setDate(date.getDate() + 1)).format(
          "YYYY-MM-DD"
        );
      }
      var a = moment([`${start_date} ${start_time}`], "YYYY-MM-DD HH:mm");
      var b = moment([`${end_date} ${end_time}`], "YYYY-MM-DD HH:mm");
      let c = b.diff(a, "hours");
      return c == 0 ? 0 : 24 - c;
    },

    preOpeningAndPostClosingRange(start, end, step = 1) {
      if (start > end) {
        step = -step;
      }
      // Determine the length of the array to be returned.
      // The length is incremented by 1 after Math.floor().
      // This ensures that the end number is listed if it falls within the range.
      const length = Math.floor(Math.abs((end - start) / step)) + 1;

      // Fill up a new array with the range numbers
      // using Array.from() with a mapping function.
      // Finally, return the new array.
      return Array.from(Array(length), (x, index) => start + index * step);
    },
    preOpeningAndPostClosingRange2(duration) {
      let calcGap = 24 - parseInt(duration);
      let result = [];
      if(calcGap > 0) {
        for (let i = 0; i <= calcGap; i += 0.5) {
          result.push(i);
        }
        result = result.filter((e)=> e <= 7);
      }
      
      return result;
    },

    changedStartTimeAndEndTimeCountHrs(opening_time, closing_time) {
      if (opening_time, closing_time) {
        var s = opening_time.slice(0, 5).split(":");
        let sMin = +s[1] + s[0] * 60,
          e = closing_time.slice(0, 5).split(":"),
          eMin = +e[1] + e[0] * 60,
          diff = eMin - sMin;
        if (diff < 0) {
          sMin -= 12 * 60;
          diff = eMin - sMin;
        }
        var h = Math.floor(diff / 60),
          m = diff % 60;
        return 24 - h;
      }
    },

    setSeconds(value) {
      if (value.toString().length == 1) {
        return "0" + value;
      }
      return value;
    },

    getStoreDetails() {
      if(!this.from_time_slot.length) {
        this.from_time_slot = this.generateStartTime(30);
      }
      // const startTimeFormatted = this.from_time_slot.find((e)=> e.value === this.is_staff_start_hours);
      // console.log(startTimeFormatted, 'startTimeFormatted')
      // this.to_time_slot = this.generateEndTime(startTimeFormatted.formatted, 30, 48);
      this.store_details = {};
      if (localStorage.getItem('store') || this.storeName) {
        this.test_store = JSON.parse(localStorage.getItem("test_store"));
        this.getStaffDetails();
        this.getAllShift();

        serverAddr
          .get(`/settings/store/details/?store=${localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName}&get_all=true`)
          .then((response) => {
            let storeData = JSON.parse(response.data);
            // console.log("storeData", storeData);
            if (storeData[0].id) {
              this.StoreId = storeData[0].store;
              this.StoreDetailsId = storeData[0].id;
              this.StoreCompany = storeData[0].company;
              this.no_of_tables = storeData[0].no_of_tables;
              this.seating_capacity = storeData[0].seating_capacity;
              this.no_of_floors = storeData[0].no_of_floors;
              this.is_staff_24_hours = storeData[0].is_staff_24_hours;
              this.shift_type = storeData[0].shift_type;
              this.business_day_time = storeData[0].business_day_time;
              this.dine_in_seats = storeData[0].no_of_dine_ins;
              this.restrooms = storeData[0].no_of_restrooms;
              this.drive_through = storeData[0].drive_through;
              this.levels = storeData[0].levels;
              this.store_size = storeData[0].store_size;
            }
          })
          .catch((err) => {
            console.error(err);
          });

        serverAddr
          .get(
            `/settings/business/days/get_all_store_times/?store=${localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName}`
          )
          .then((response) => {
            let business = JSON.parse(response.data).results;
            console.log(business, 'businessbusinessbusiness')
            // if(business) {
            //   if (business.length > 7) {
            //     business.length = 7;
            //   }
            // }

            if(business) {
              if (business.length) {
                for (let i = 0; i < business.length; i++) {
                  business[i].hrs = 24;
                  var s = business[i].opening_time.split(":"),
                    sMin = +s[1] + s[0] * 60,
                    e = business[i].closing_time.split(":"),
                    eMin = +e[1] + e[0] * 60,
                    diff = eMin - sMin;
                  if (diff < 0) {
                    sMin -= 12 * 60;
                    diff = eMin - sMin;
                  }
                  var h = Math.floor(diff / 60),
                    m = diff % 60;
                  business[i].hrs = 24 - h;
                }
              }
            }
            
            this.getBusinessList(business); 
          })
          .catch((err) => {
            this.getBusinessList([]);
            console.log(err);
          });
      }
    },

    setCloseAll() {
      // if (!this.isClosed && this.is_staff_start_hours == 1) {
      //   this.openforBusiness.forEach((element) => {
      //     element.opening_time = "00:00";
      //     element.closing_time = "00:00";
      //   });
      // }
      // this.openforBusiness.forEach((element, elmIndex) => {
      //   if(element.closing_time){
      //     element.to_time_slot = this.generateEndTime(this.from_time_slot.find((e)=> e.value === element.opening_time).formatted, 30, 48);
      //   } else {
      //     element.to_time_slot = this.generateEndTime(this.from_time_slot.find((e)=> e.value === "09:00:00").formatted, 30, 48);
      //   }
      //   this.updateDuration(element.opening_time, element.closing_time, element.pre_opening_hour, element.post_opening_hour, elmIndex);
      // });
    },

    changeOpeningTime(itemIndex, opening_time) {
      // first check selected input is monday & is first time insert value of opening time on monday
      // if (
      //   this.openforBusiness[itemIndex].day === 2 &&
      //   !this.first_opening_time
      // ) {
      //   this.openforBusiness.forEach((element, element_index) => {
      //     // check upto friday
      //     if (element.day < 7) {
      //       element.opening_time = opening_time; // opening time copy paste monday to friday
      //     }
      //   });
      //   this.first_opening_time = true;
      // }
      //  Validate by duration
      // const duration = this.getShiftDuration(this.openforBusiness[itemIndex].opening_time, this.openforBusiness[itemIndex].closing_time, this.openforBusiness[itemIndex].pre_opening_hour, this.openforBusiness[itemIndex].post_opening_hour);
      // if((duration > 24 || duration <= 0) && (this.openforBusiness[itemIndex].opening_time && this.openforBusiness[itemIndex].closing_time)) {
      //   this.openforBusiness[itemIndex].opening_time = '';
      //   this.$forceUpdate();
      // }
      // // Update all time slots
      if(opening_time) {
        this.openforBusiness[itemIndex].to_time_slot = this.generateEndTime(this.from_time_slot.find((e)=> e.value === opening_time).formatted, 30, 48);
      }
      console.log(opening_time, 'opening_time');
      // this.changedStartTimeAndEndTimeCountHrs(itemIndex);
      if(!opening_time) {
        this.openforBusiness[itemIndex].duration = 0;
      }
      this.openPopup();
    },

    changeClosingTime(itemIndex, closing_time, opening_time) {
      // first check selected input is monday & is first time insert value of closing time on monday
      // if (
      //   this.openforBusiness[itemIndex].day === 2 &&
      //   !this.first_closing_time
      // ) {
      //   this.openforBusiness.forEach((element, element_index) => {
      //     // check upto friday
      //     if (element.day < 7) {
      //       element.closing_time = closing_time; // closing time copy paste monday to friday
      //       element.hrs = this.changedStartTimeAndEndTimeCountHrs(
      //         element.opening_time,
      //         element.closing_time
      //       );
      //     }
      //   });
      //   this.first_closing_time = true;
      // } else {
      //   this.openforBusiness[itemIndex].hrs =
      //     this.changedStartTimeAndEndTimeCountHrs(opening_time, closing_time);
      // }

      //  Validate by duration
      // const duration = this.getShiftDuration(this.openforBusiness[itemIndex].opening_time, this.openforBusiness[itemIndex].closing_time, this.openforBusiness[itemIndex].pre_opening_hour, this.openforBusiness[itemIndex].post_opening_hour);
      // if((duration > 24 || duration <= 0) && (this.openforBusiness[itemIndex].opening_time && this.openforBusiness[itemIndex].closing_time)) {
      //   this.openforBusiness[itemIndex].closing_time = '';
      //   this.$forceUpdate();
      // }

      this.openPopup();
    },

    changeHrsFormat() {
      if (this.is_staff_24_hours == 1) {
        // this.isClosed = true;
        if (this.isClosed) {
          this.is_staff_start_hours = "00:00:00";
          this.is_staff_end_hours = "00:00:00";
          [this.pre_opening_hour, this.pre_opening_min] = "00:00".split(":");
          [this.post_opening_hour, this.post_opening_min] = "00:00".split(":");
        } else {
          this.openforBusiness.forEach((element, element_index) => {
            // check upto friday
            element.opening_time = "00:00"; // closing time copy paste monday to friday
            element.closing_time = "00:00"; // closing time copy paste monday to friday
            element.pre_opening_hour = "0"; // closing time copy paste monday to friday
            element.post_opening_hour = "0"; // closing time copy paste monday to friday
            element.pre_opening_min = "0"; // closing time copy paste monday to friday
            element.post_opening_min = "0"; // closing time copy paste monday to friday
            element.hrs = this.changedStartTimeAndEndTimeCountHrs(
              element.opening_time,
              element.closing_time
            );
            // if (element.day < 7) {
            // }
          });
        }
      } else {
        // set all values, when is_staff_24_hours selected as yes
        this.is_staff_start_hours = this.openforBusiness[0].opening_time;
        this.is_staff_end_hours = this.openforBusiness[0].closing_time;
        this.pre_opening_hour = this.openforBusiness[0].pre_opening_hour;
        this.post_opening_hour = this.openforBusiness[0].post_opening_hour;
        // [
        // 	this.pre_opening_hour,
        // 	this.pre_opening_min
        // ] = this.store_details.pre_opening_time ? this.store_details.pre_opening_time.split(":") : ("00:00").split(":");
        // [
        // 	this.post_opening_hour,
        // 	this.post_opening_min
        // ] = this.store_details.post_opening_time ? this.store_details.post_opening_time.split(":") : ("00:00").split(":");
      }
      this.changeKeys = true;
    },

    openPopup() {
      this.changeKeys = true;
    },

    addCloseTime() {
      if (this.isClosed) {
        this.openforBusiness.forEach((element) => {
          element.opening_time = this.is_staff_start_hours;
          element.closing_time = this.is_staff_end_hours;
        });
      } else {
        this.openforBusiness.forEach((element) => {
          element.opening_time = "";
          element.closing_time = "";
        });
      }
      this.changeKeys = true;
      // console.log(this.openforBusiness);
    },

    getBusinessList(business) {
      console.log(business, 'business')
      if (business) {
        if (business.length) {

          //  Set it independent 
          business.map((e)=>{
            this.openforBusiness.map((el)=>{
              if(e.day === el.day){
                el.opening_time = e.opening_time;
                el.closing_time = e.closing_time;
                el.pre_opening_hour = e.pre_opening_hour;
                el.pre_opening_min = e.pre_opening_min;
                el.post_opening_hour = e.post_opening_hour;
                el.post_opening_min = e.post_opening_min;
                el.closed = e.closed;
                el.location = e.location;
                el.company = e.company;
              } else if(e.day === 1) {
                el.opening_time = '';
                el.closing_time = '';
                el.pre_opening_hour = '';
                el.pre_opening_min = 0;
                el.post_opening_hour = '';
                el.post_opening_min = 0;
                el.closed = false;
                el.location = '';
                el.company = '';
                el.duration = '';
              }
            })
          })
          // this.openforBusiness = business;


          this.is_staff_start_hours =
            this.store_details.is_staff_24_hours == 2
              ? "00:00"
              : this.openforBusiness[0].opening_time;
          this.is_staff_end_hours =
            this.store_details.is_staff_24_hours == 1
              ? "00:00"
              : this.openforBusiness[0].closing_time;
          this.pre_opening_hour =
            this.store_details.is_staff_24_hours == 2
              ? "00:00"
              : this.openforBusiness[0].pre_opening_hour;
          this.pre_opening_min =
            this.store_details.is_staff_24_hours == 1
              ? "00:00"
              : this.openforBusiness[0].pre_opening_min;
          this.post_opening_hour =
            this.store_details.is_staff_24_hours == 2
              ? "00:00"
              : this.openforBusiness[0].post_opening_hour;
          this.post_opening_min =
            this.store_details.is_staff_24_hours == 1
              ? "00:00"
              : this.openforBusiness[0].post_opening_min;

          var arrayLength = this.openforBusiness.length + 2;

          for (var i = arrayLength; i < 9; i++) {
            this.openforBusiness.push({
              day: i,
              opening_time: "",
              closing_time: "",
              closed: false,
            });
          }

          // Call time slot function here
          this.from_time_slot = this.generateStartTime(30);
          const startTimeFormatted = this.from_time_slot.find((e) => e.value === this.is_staff_start_hours)
          this.to_time_slot = this.generateEndTime(startTimeFormatted.formatted, 30, 48);
          // this.to_time_slot = this.generateEndTime(this.is_staff_start_hours, 30);

          this.openforBusiness.forEach((element, elmIndex) => {
            element.duration = this.getShiftDuration(element.opening_time, element.closing_time, element.pre_opening_hour, element.post_opening_hour);
            element.to_time_slot = this.getShiftDuration(element.opening_time, element.closing_time, element.pre_opening_hour, element.post_opening_hour);
            if (element.closing_time) {
              console.log(element.closing_time, 'element.closing_time')
              element.to_time_slot = this.generateEndTime(this.from_time_slot.find((e) => e.value === element.opening_time).formatted, 30, 48);
            } else {
              element.to_time_slot = this.generateEndTime(this.from_time_slot.find((e) => e.value === "09:00:00").formatted, 30, 48);
            }
          });
        }
      } else {
        console.log('-')
        this.openforBusiness = [
          {
            day: 2,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 3,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 4,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 5,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 6,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 7,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
          {
            day: 8,
            opening_time: "",
            closing_time: "",
            pre_opening_hour: "",
            pre_opening_min: 0,
            post_opening_hour: "",
            post_opening_min: 0,
            closed: false,
            to_time_slot: [],
            duration: 0,
          },
        ];
        this.$forceUpdate();
      }
    },

    getAllShift() {
      if (this.storeName) {
        let params = {
          outlet_id: localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName,
        };
        LabourPalnningService.getShiftForStoreDetails(params)
          .then((response) => {
            let shift = JSON.parse(response.data);
            if (shift.length) {
              this.shifts = shift;
            } else {
              this.shifts = [
                {
                  shift_name: "",
                  shift_start_time: "",
                  shift_end_time: "",
                  min_staff_required: 0,
                },
                {
                  shift_name: "",
                  shift_start_time: "",
                  shift_end_time: "",
                  min_staff_required: 0,
                },
              ];
            }
          })
          .catch((error) => {
            console.log("error", error);
          });
      }
      // /read/store-shifts/
    },

    addShiftType() {
      let params = {
        store: this.storeName,
        shift_type: this.shift_type,
        shifts: this.shifts,
      };
      LabourPalnningService.addShiftForStoreDetails(params)
        .then((response) => {
          if (response.status == 200) {
            console.log(JSON.parse(response.data));
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },

    addStoreDetails() {
      this.createNewSection();
      if (!this.no_of_tables) {
        this.no_of_tables = 0;
      }
      if (!this.seating_capacity) {
        this.seating_capacity = 0;
      }
      if (!this.no_of_floors) {
        this.no_of_floors = 0;
      }

      this.$validator.validateAll().then(
        async function (result) {
          if (result) {

            let startTime = '';
            let endTime = '';

            let total = 0;

            if (this.isClosed) {
              startTime = moment(this.is_staff_start_hours, "HH:mm:ss");
              endTime = moment(this.is_staff_end_hours, "HH:mm:ss");

              // calculate total duration
              let duration = moment.duration(endTime.diff(startTime));

              let pre_opening_hours = Number(this.pre_opening_hour) + Number(this.post_opening_hour);

              total = pre_opening_hours + Number(moment.utc(duration.as('milliseconds')).format("HH"));
            } else if (!this.isClosed && this.openforBusiness.length && this.openforBusiness[0].opening_time && this.openforBusiness[0].closing_time ) {

              startTime = moment(this.openforBusiness[0].opening_time, "HH:mm:ss");
              endTime = moment(this.openforBusiness[0].closing_time, "HH:mm:ss");

              // calculate total duration
              let duration = moment.duration(endTime.diff(startTime));

              let pre_opening_hours = Number(this.openforBusiness[0].pre_opening_hour) + Number(this.openforBusiness[0].post_opening_hour);

              total = pre_opening_hours + Number(moment.utc(duration.as('milliseconds')).format("HH"));
            }

            
            // if only store opening & closing hours are greater than 9 hours
            console.log(moment.duration(this.store_staff_info.full_time_duration_day_max).asHours(), 'As Hours')
            let max_hrs = moment.duration(this.store_staff_info.full_time_duration_day_max).asHours() ? moment.duration(this.store_staff_info.full_time_duration_day_max).asHours() : 9.5;
            const isAnyDurationLessThanThreshold = this.openforBusiness.some(item => item.duration < max_hrs);
            console.log(total,max_hrs,this.openforBusiness.some(item => item.duration > max_hrs ), 'total');
            if (!isAnyDurationLessThanThreshold || this.is_staff_24_hours == 1) {
              var params = {
                store: this.storeName,
                is_staff_24_hours: this.is_staff_24_hours,
                no_of_tables: this.no_of_tables,
                seating_capacity: this.seating_capacity,
                no_of_floors: this.no_of_floors,
                shift_type: this.shift_type,
                no_of_dine_ins: this.dine_in_seats,
                no_of_restrooms: this.restrooms,
                drive_through: this.drive_through,
                levels: this.levels,
                store_size: this.store_size ? Number(this.store_size) : 0,
              };
              
              params.business_day_time = this.business_day_time;

              this.StoreCompany != "" ? (params.company = this.StoreCompany) : "";

              if (this.restricted_start_time && this.restricted_end_time && Object.keys(this.staff_details).length) {
                let staffDetailsRes = await this.addStaffDetails(this.restricted_start_time, this.restricted_end_time);
              } else {
                await this.addStaffDetails("", "");
              }

              if (this.changeKeys) {
                this.addBusinessDays(this.storeName);
                  this.dataUpdate = true;
                  if (this.StoreDetailsId != "") {
                    serverAddr
                      .patch(
                        `/settings/store/details/${this.StoreDetailsId}/`,
                        params
                      )
                      .then((response) => {
                        if (response.status == 200) {
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  } else {
                    LabourPalnningService.addStoreDetails(params)
                      .then((response) => {
                        if (response.status == 200) {
                        }
                      })
                      .catch((err) => {
                        console.log(err);
                      });
                  }
              } else {
                if (this.shift_type == "fixed") {
                  this.addShiftType();
                }
                if (this.StoreDetailsId != "") {
                  serverAddr
                    .patch(
                      `/settings/store/details/${this.StoreDetailsId}/`,
                      params
                    )
                    .then((response) => {
                      if (response.status == 200) {
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    }).finally(()=>{
                      this.addBusinessDays(this.storeName);
                    });
                } else {
                  LabourPalnningService.addStoreDetails(params)
                    .then((response) => {
                      if (response.status == 200) {
                      }
                    })
                    .catch((err) => {
                      console.log(err);
                    });
                }
              }
            } else {
              this.$alert(`Store timings cannot be less than ${max_hrs} Hrs`, 'Error', {
                confirmButtonText: 'OK',
                callback: action => { }
              });
            }



            // console.log("esefghsdghjsgdhjghj", this.StoreDetailsId)
          } else {
            this.$message.error("Required fields are missing");
          }
        }.bind(this)
      );
    },

    addBusinessDays(storeId) {
      if (this.isClosed) {
        this.openforBusiness.forEach((e) => {
          e.opening_time = this.is_staff_start_hours;
          e.closing_time = this.is_staff_end_hours;
          e.pre_opening_hour = this.pre_opening_hour
            ? this.pre_opening_hour
            : 0;
          e.pre_opening_min = "0";
          e.post_opening_hour = this.post_opening_hour
            ? this.post_opening_hour
            : 0;
          e.post_opening_min = "0";
        });
      }

      var temp = this.openforBusiness.map((e) => {
        let obj = {
          store: this.storeName,
          day: e.day,
          opening_time: e.opening_time.length == 5 ? e.opening_time + ":00" : e.opening_time,
          closing_time: e.closing_time,
          pre_opening_hour: e.pre_opening_hour ? e.pre_opening_hour : 0,
          post_opening_hour: e.post_opening_hour ? e.post_opening_hour : 0,
          closed: e.closed,
        };

        e.id ? (obj.id = e.id) : "";
        e.company ? (obj.company = e.company) : "";
        return obj;
      });
      // var openingList = this.openforBusiness.map(e => {
      // 	let obj = {
      // 		store: this.storeName,
      // 		day: e.day,
      // 		// if single business hour are selected then set v-model value for each element otherwise sent each hours to per elements of array
      // 		pre_opening_hour: e.pre_opening_hour ? e.pre_opening_hour : 0,
      // 		pre_opening_min: 0,
      // 		post_opening_hour: e.post_opening_hour ? e.post_opening_hour : 0,
      // 		post_opening_min: 0,
      // 		closed: e.closed
      // 	};
      // 	e.openingId ? (obj.id = e.openingId) : "";
      // 	e.openingCompany ? (obj.company = e.openingCompany) : "";
      // 	return obj;
      // });
      // serverAddr
      // 	.post("/settings/business/days/create-update/", temp)
      // 	.then(response => {
      // 		if (response.status == 200) {
      // 		}
      // 	})
      // 	.catch(err => {
      // 		console.log(err);
      // 	});
      serverAddr
        .post("/settings/business/days/create-update-all-times/", temp)
        .then((response) => {
          if (response.status == 200) {
            this.isRouteChanged = true;
            this.$notify.success({
              title: "Success",
              message: "Store Details Updated successfully",
            });
            this.getStoreDetails();
            this.changeKeys = false;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    changeUrl() {
      this.isRouteChanged = true;
      this.isShowPopUp = false;
      this.$router.push({ path: this.path });
    },

    addStaffDetails(start_time, end_time) {
      this.staff_details.restricted_start_time = start_time
        ? start_time + ":00"
        : null;
      this.staff_details.restricted_end_time = end_time
        ? end_time + ":00"
        : null;
      console.log(start_time, end_time, 'this.staff_details')
        this.staff_details.female_end_time = moment(this.staff_details.female_end_time, "HH:mm:ss A").format("HH:mm:ss");
        this.staff_details.female_start_time = moment(this.staff_details.female_start_time, "HH:mm:ss A").format("HH:mm:ss");
        this.staff_details.pt_female_end_time = moment(this.staff_details.pt_female_end_time, "HH:mm:ss A").format("HH:mm:ss");
        this.staff_details.pt_female_start_time = moment(this.staff_details.pt_female_start_time, "HH:mm:ss A").format("HH:mm:ss");

      return LabourPalnningService.addStaffDetails(this.staff_details)
        .then((response) => {
          return response;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    getStaffDetails() {
      var params = {
        outlet_id: localStorage.getItem('store') ? localStorage.getItem('store') : this.storeName,
      };

      return LabourPalnningService.getStaffDetails(params)
        .then((response) => {
          if (response.status == 200) {
            this.staff_details = JSON.parse(response.data);
            this.store_staff_info = JSON.parse(response.data);
            this.restricted_start_time =
              this.staff_details && this.staff_details.restricted_start_time
                ? this.staff_details.restricted_start_time.slice(0, 5)
                : "";
            this.restricted_end_time =
              this.staff_details && this.staff_details.restricted_end_time
                ? this.staff_details.restricted_end_time.slice(0, 5)
                : "";
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
  },

  beforeRouteLeave(to, from, next) {
    if (
      this.changeKeys
      // this.is_staff_24_hours != "" ||
      // this.openforBusiness[0].closing_time != "" ||
      // this.openforBusiness[0].opening_time != ""
    ) {
      this.isShowPopUp = true;
    } else {
      this.isRouteChanged = true;
    }
    // this.isShowPopUp = true;
    this.path = to.path;
    if (this.isRouteChanged) {
      next();
    } else {
      next(false);
    }
  },
};
</script>

<style lang="scss" scoped>
@import "./StoreDetails.scss";
</style>

<style lang="scss">
.lowercase .el-input__inner {
  text-transform: lowercase;
}

.StoreDetails .el-input__inner {
  text-transform: capitalize;
}

.StoreDetails .custom-time-picker-wrapper {
  position: relative;

  .custom-time-picker input {
    padding-left: 30px;
    cursor: text;
  }

  .time-icon {
    height: 100%;
    width: 25px;
    text-align: center;
    -webkit-transition: all 0.3s;
    transition: all 0.3s;
    line-height: 40px;
    color: #c0c4cc;
    position: absolute;
    left: 5px;
    z-index: 1;
    font-size: 14px;
  }
}

// Css for section header
.nymb-section-head-sec {
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    display: flex;
    align-items: center;

    .btn {
      margin-left: 10px;
      color: #fff !important;
    }

    button {
      color: #fff;
    }

    .btn:hover {
      button {
        color: #e29d5a !important;
      }
    }
  }

  .sec-btn {
    color: #fff !important;
  }
}

// CSS For table
.nymbl-section-list-tabel {
  width: auto;
  border-collapse: collapse;
  border-spacing: 0;
  border: none;
  text-align: center !important;

  thead {

    // background-color: #4b2519 !important;
    tr th {
      // color: #fff ;
      // font-size: 14px;
      // text-align: center;
    }
  }

  tbody tr td {
    // font-size: 16px !important;
    // border-top: 1px solid #ddd;
    // padding: 25px 0;
    // color: #4b2519 !important;
    // text-align: center !important;
  }

  i {
    font-size: 18px;
    margin-right: 0.5rem;
    color: #e29d5a;
    cursor: pointer;
  }

  i:last-child {
    // margin-left: 15px;
  }
}

.event-table {
  margin-top: 25px;

  table tbody {
    // max-height: 600px !important;
    // height: 100% !important;
    // margin-bottom: 25px;
  }
}

.el-scrollbar__wrap {
  height: 100% !important;
}

.el-button--primary {
  color: #fff;
  background-color: #e29d5a !important;
  border-color: #e29d5a !important;
}

.el-button--primary:focus,
.el-button--primary:hover {
  background: #e29d5a !important;
  border-color: #e29d5a !important;
  color: #fff;
}

.sec-btn {
  button {
    color: #fff;
  }
}

.sec-btn:hover {
  button {
    color: #e29d5a;
  }
}

.border-top-btn-sec {
  padding-top: 15px;
  border-top: 1px solid #dae1e7;
}

.nymb-section-body-sec i {
  font-size: 22px;
}

.el-button.submit-btn {
  background: #d26300;
  border-color: #d26300;
  color: #fff;
  min-width: 100px;
}

.el-button.cancel-btn {
  background: #fff;
  border-color: #d26300;
  color: #d26300;
  min-width: 100px;
}
</style>
